'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPolicyEditPage, SETTINGS_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/$id/')({
  component: AuthPolicyEditRoute
});
function AuthPolicyEditRoute() {
  const {
    id
  } = Route.useParams();
  return <AuthPolicyEditPage paths={SETTINGS_AUTH_POLICY_PATHS} id={id} />;
}